const baseurl = 'https://cdn.obsess-vr.com/';

const nature = [
    // {
    //     name: 'slipknot lowa',
    //     src: baseurl + 'umg/14-Iowa.mp3',
    //     artist: 'slipknot',
    //     img: ''
    // }
    {
        name: 'K Perry-Electric',
        src: baseurl + 'umg/music/24b-01-K-Perry-Electric_SEQ2.wav',
        artist: 'BECKER MASTER',
        img: ''
    },
    {
        name: 'JJ Phases',
        src: baseurl + 'umg/music/24b-02-JJ_Phases-Mix-1pt2-BECKER-MASTER_SEQ2.wav',
        artist: 'BECKER MASTER',
        img: ''
    },
    {
        name: 'M Take It Home',
        src: baseurl + 'umg/music/24b-03-M_Take0-It-Home_BECKER-MASTER_SEQ2.wav',
        artist: 'BECKER MASTER',
        img: ''
    },
    {
        name: 'LY Believing',
        src: baseurl + 'umg/music/24b-04-LY_Believing_BECKER-MASTER-2_SEQ2.wav',
        artist: 'BECKER MASTER',
        img: ''
    },
    {
        name: 'C WONDERFUL',
        src: baseurl + 'umg/music/24b-06-C_WONDERFUL-REF-1_BECKER-MASTER_SEQ2.wav',
        artist: 'BECKER MASTER',
        img: ''
    },
    {
        name: 'VS Got',
        src: baseurl + 'umg/music/24b-07-VS_Got-Em-Update_2_BECKER-MASTER_SEQ2.wav',
        artist: 'BECKER MASTER',
        img: ''
    },
    {
        name: 'L Game Girl',
        src: baseurl + 'umg/music/24b-08-L_Game-Girl_BECKER-MASTER_SEQ2.wav',
        artist: 'BECKER MASTER',
        img: ''
    },
    {
        name: 'TW Art Show',
        src: baseurl + 'umg/music/24b-09-TW_Art-Show-M_v1_0_BECKER-MASTER_SEQ2.wav',
        artist: 'BECKER MASTER',
        img: ''
    },
    {
        name: 'PM Only Wanna Be With You',
        src: baseurl + 'umg/music/24b-10-PM_Only-Wanna-Be-With-You-Update-2-From-BG-Mst_BECKER-MASTER_SEQ2.wav',
        artist: 'BECKER MASTER',
        img: ''
    },
    {
        name: 'Y Reconnect',
        src: baseurl + 'umg/music/24b-11-Y_Reconnect-06262021_BECKER-MASTER_2.wav',
        artist: 'BECKER MASTER',
        img: ''
    },
];


export default {
    nature
}
